export default __webpack_public_path__ + "static/sodexo-faded.url-fd92744e21de48b778dc98cc634c6501.svg";